import React, {Component} from "react";
import {Result} from 'antd';

class SearchStockByVariant extends Component<any, any> {
    private initState!: any;

    constructor(props: any) {
        super(props);

        this.initState = {
            aa: "",
        }
        this.state = {...this.initState}
    }

    onClickBtnStockUnit = async () => {
        alert('clicked')
    }

    async componentDidMount() {

    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {

    }

    render() {
        return (
            <Result
                status="404"
                title="Under Construct"
                subTitle="Maaf, Halaman / Modul / Section berikut masih dalam proses pembuatan."
            />
        );
    }
}

export default SearchStockByVariant;
